import {
  ModalContent,
  ModalHeader,
  ModalRoot,
  ModalTitle,
} from '@synoptic/ui-kit/modal/modal.js';
import { PropsWithChildren, useContext } from 'react';
import { OnboardingContext } from '@/routes/_app.terminal._index/terminal/onboarding/onboarding-context';
import {
  ONBOARDING_TARGETS,
  onboardingTargetProps,
} from '@/routes/_app.terminal._index/terminal/onboarding/onboarding-targets';
import { tourOverlay } from '@/routes/_app.terminal._index/terminal/onboarding/tour-overlay.css';

export const ManageListModal = ({
  children,
  isOpen,
  onOpenChange,
  title,
}: PropsWithChildren<{
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  title: string;
}>) => {
  // The tour spotlights a field in here, so the modal has to stay open and
  // leave the rest of the page reachable while it does.
  const tourRunning = useContext(OnboardingContext)?.flowState === 'running';

  return (
    <ModalRoot open={isOpen} onOpenChange={onOpenChange} modal={!tourRunning}>
      <ModalContent
        preventOutsideClose={tourRunning}
        staticOverlay={tourRunning}
        overlayClassName={tourRunning ? tourOverlay : undefined}
        {...onboardingTargetProps(ONBOARDING_TARGETS.editListModal)}
      >
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
        </ModalHeader>
        <div>{children}</div>
      </ModalContent>
    </ModalRoot>
  );
};
